/* tslint:disable */
/* eslint-disable */
/**
 * Ster.nl API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  SterWebsiteModelPriceCompareCalculateRequest,
  SterWebsiteModelPriceCompareCalculateRequestFromJSON,
  SterWebsiteModelPriceCompareCalculateRequestToJSON,
  SterWebsiteModelPriceCompareCalculateResult,
  SterWebsiteModelPriceCompareCalculateResultFromJSON,
  SterWebsiteModelPriceCompareCalculateResultToJSON,
  SterWebsiteModelPriceCompareMetadata,
  SterWebsiteModelPriceCompareMetadataFromJSON,
  SterWebsiteModelPriceCompareMetadataToJSON,
} from "../models";
import * as runtime from "../runtime";

export interface PriceCompareCalculateRequest {
  medium: string;
  request: SterWebsiteModelPriceCompareCalculateRequest;
}

export interface PriceCompareMetadataRequest {
  medium: string;
}

/**
 *
 */
export class PriceCompareApi extends runtime.BaseAPI {
  /**
   */
  async priceCompareCalculateRaw(
    requestParameters: PriceCompareCalculateRequest
  ): Promise<runtime.ApiResponse<SterWebsiteModelPriceCompareCalculateResult>> {
    if (
      requestParameters.medium === null ||
      requestParameters.medium === undefined
    ) {
      throw new runtime.RequiredError(
        "medium",
        "Required parameter requestParameters.medium was null or undefined when calling priceCompareCalculate."
      );
    }

    if (
      requestParameters.request === null ||
      requestParameters.request === undefined
    ) {
      throw new runtime.RequiredError(
        "request",
        "Required parameter requestParameters.request was null or undefined when calling priceCompareCalculate."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request({
      path: `/api/priceCompare/calculate/{medium}`.replace(
        `{${"medium"}}`,
        encodeURIComponent(String(requestParameters.medium))
      ),
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: SterWebsiteModelPriceCompareCalculateRequestToJSON(
        requestParameters.request
      ),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SterWebsiteModelPriceCompareCalculateResultFromJSON(jsonValue)
    );
  }

  /**
   */
  async priceCompareCalculate(
    requestParameters: PriceCompareCalculateRequest
  ): Promise<SterWebsiteModelPriceCompareCalculateResult> {
    const response = await this.priceCompareCalculateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async priceCompareMetadataRaw(
    requestParameters: PriceCompareMetadataRequest
  ): Promise<runtime.ApiResponse<SterWebsiteModelPriceCompareMetadata>> {
    if (
      requestParameters.medium === null ||
      requestParameters.medium === undefined
    ) {
      throw new runtime.RequiredError(
        "medium",
        "Required parameter requestParameters.medium was null or undefined when calling priceCompareMetadata."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/api/priceCompare/metadata/{medium}`.replace(
        `{${"medium"}}`,
        encodeURIComponent(String(requestParameters.medium))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SterWebsiteModelPriceCompareMetadataFromJSON(jsonValue)
    );
  }

  /**
   */
  async priceCompareMetadata(
    requestParameters: PriceCompareMetadataRequest
  ): Promise<SterWebsiteModelPriceCompareMetadata> {
    const response = await this.priceCompareMetadataRaw(requestParameters);
    return await response.value();
  }
}
